import { accountIdFormat } from "@redotech/redo-account-id";
import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { SortDispositionSchema } from "./sort-disposition";

/**
 * Allowed sort-destination colors. Stored as hex because the column predates
 * the palette with a '#FFFFFF' default, so white doubles as "no color".
 */
export const SortDestinationColor = {
  white: "#FFFFFF",
  gray: "#98A2B3",
  red: "#F04438",
  orange: "#EF6820",
  yellow: "#EAAA08",
  green: "#17B26A",
  teal: "#15B79E",
  blue: "#2E90FA",
  purple: "#7A5AF8",
  pink: "#EE46BC",
} as const;
export type SortDestinationColor =
  (typeof SortDestinationColor)[keyof typeof SortDestinationColor];

export const SortDestinationColorSchema = z.enum([
  SortDestinationColor.white,
  SortDestinationColor.gray,
  SortDestinationColor.red,
  SortDestinationColor.orange,
  SortDestinationColor.yellow,
  SortDestinationColor.green,
  SortDestinationColor.teal,
  SortDestinationColor.blue,
  SortDestinationColor.purple,
  SortDestinationColor.pink,
]);

export const SortDestinationRecordSchema = z.object({
  id: sortDestinationIdFormat.schema,
  accountId: accountIdFormat.schema,
  disposition: SortDispositionSchema,
  name: z.string(),
  color: SortDestinationColorSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
});
export type SortDestinationRecord = z.infer<typeof SortDestinationRecordSchema>;
